// src/services/sugerenciaService.ts

import api from "../api/axiosInstance";
import {
  Sugerencia,
  SugerenciaResponse,
} from "src/models/types";

// 🟢 Guardar sugerencia (usuario final)
export const guardarSugerencia = async (
  data: Sugerencia
): Promise<SugerenciaResponse> => {
  const resp = await api.post<SugerenciaResponse>("/sugerencias/guardar", data);
  return resp.data; 
};
